export default __webpack_public_path__ + "static/media/gallery - prince vs clean_00.08dc5dc7.jpg";